<template>
  <el-dialog
    title="规则策略"
    :visible.sync="innerVisible"
    width="900px"
    @close="onClose"
  >
    <el-tabs v-model="strategyType" @tab-click="onTabClick">
      <el-tab-pane
        v-for="item in strategySourceList"
        :key="item.value"
        :label="item.name"
        :name="String(item.value)"
      ></el-tab-pane>
    </el-tabs>

    <el-table
      ref="strategyTable"
      v-loading="loading"
      :data="list"
      row-key="strategyCode"
      style="width: 100%; max-height: 300px"
      :header-cell-style="{ color: '#1a1e25', background: '#f5f5f5' }"
      @selection-change="onCheck"
    >
      <el-table-column
        type="selection"
        width="55"
        :reserve-selection="true"
        :selectable="isSelectable"
      ></el-table-column>
      <el-table-column label="策略名称" prop="strategyName" min-width="200">
        <template slot-scope="{ row }">
          <span
            :title="isPicked(row) ? '该策略已被选！' : ''"
            :class="{ 'is-picked': isPicked(row) }"
          >
            {{ row["strategyName"] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="策略标识" prop="strategyCode" width="300">
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" size="small" @click="onConfirm"
        >提 交</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  StrategySourceList,
  EnumStrategySource,
} from "@/enum/dict/machine-rule.js";
import { getStrategyListAPI } from "../api";

export default {
  name: "StrategySelectDialog",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 仅排除当前规则组中已选的策略。
    pickedCodes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      // Element tab 的 name 使用字符串，接口参数再转为数字。
      strategyType: String(EnumStrategySource.SYSTEM),
      list: [],
      checked: [],
      loading: false,
      listRequestId: 0,
    };
  },

  computed: {
    // 所有规则类型共用来源列表，智租暂不上线。
    strategySourceList() {
      return StrategySourceList;
    },
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },

  watch: {
    visible(val) {
      if (!val) return;
      this.strategyType = String(EnumStrategySource.SYSTEM);
      this.checked = [];
      this.list = [];
      this.getList();
    },
  },

  methods: {
    async getList() {
      const requestId = ++this.listRequestId;
      this.loading = true;
      try {
        const res = await getStrategyListAPI({
          strategyType: Number(this.strategyType),
        });
        if (requestId === this.listRequestId) {
          this.list = res || [];
        }
      } catch {
        // 请求错误由 http 统一提示。
      } finally {
        if (requestId === this.listRequestId) {
          this.loading = false;
        }
      }
    },
    // 表格按策略标识保留跨来源勾选，提交时包含所有来源的已选策略。
    onTabClick() {
      this.getList();
    },
    isPicked(row) {
      return this.pickedCodes.indexOf(row["strategyCode"]) > -1;
    },
    isSelectable(row) {
      return !this.isPicked(row);
    },
    onCheck(rows) {
      this.checked = rows || [];
    },
    onConfirm() {
      this.$emit("confirm", this.checked);
      this.innerVisible = false;
    },
    onClose() {
      this.listRequestId++;
      this.loading = false;
      this.$refs.strategyTable && this.$refs.strategyTable.clearSelection();
      this.checked = [];
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-dialog .el-table {
  overflow-y: scroll;

  &::before {
    display: none;
  }

  .el-table__cell {
    padding: 8px 0;
  }

  .is-picked {
    color: #c0c4cc;
    cursor: not-allowed;
  }
}
</style>
